var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 108,
    viewBox: "0 0 204 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.927 88.5829C134.601 96.0052 118.92 100.015 99.2713 101.948C76.9876 101.334 61.5267 97.8784 47.6863 90.7128C34.5859 83.9302 22.5645 73.6407 7.46048 58.3814C23.4714 37.6383 37.8508 24.6075 53.082 16.7333C69.0769 8.46422 86.5408 5.60903 108.849 6.16658C136.216 9.65298 159.441 23.3095 195.144 57.4258C178.293 71.7582 164.155 81.6928 149.927 88.5829Z",
    stroke: "black",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftEye);
export default __webpack_public_path__ + "static/media/left_eye.0e79721558ca4f349a0c3f52339e4799.svg";
export { ForwardRef as ReactComponent };